"use strict";

var Dispatcher = require("flux").Dispatcher;

module.exports = new Dispatcher();



// WEBPACK FOOTER //
// ./Javascript/accountComponents/Dispatcher.jsx